import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterParentingCheckboxGroup} from "./parenting-checkbox-group.js";

export class FilterParentingCheckboxList extends AbstractFilterComponent {

	selectorParent = '.js-filter-checkbox-parent';
	selectorChild = '.js-filter-checkbox-child';

	groups = [];

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.initChildren();
	}

	initChildren() {
		let self = this;

		self.groups = Array.prototype.slice.call(self.node.querySelectorAll(self.selectorParent)).map(parent => {
			return new FilterParentingCheckboxGroup(self, self.filter, parent, self.findChildren(parent));
		});
	}

	findChildren(parent) {
		let self = this;

		return Array.prototype.slice.call(self.node.querySelectorAll(`${self.selectorChild}[data-parent="${parent.id}"]`));
	}

	setCheckedState(state) {
		let self = this;
		self.groups.forEach(checkbox => {
			checkbox.setCheckedState(state);
		});
	}

	getLabels() {
		let self = this;
		let labels = [];

		self.groups.map(group => {
			group.getLabels().filter(Boolean).map(label => {
				labels.push(label);
			});
		});

		return labels;
	}

	getFormData() {
		let self = this;
		let data = {};

		self.groups.forEach(group => {
			data = {...data, ...group.getFormData() };
		});

		return data;
	}
}
